<template>
  <section class="tvb-terms">
    <Faq
      :title="language === 'en' ? 'FAQ' : '常見問題'"
      :key="language"
      :selected="2"
      :lang="language"
      @change-lang="changeLang"
    >
      <div v-if="language === 'tc'" class="corporation-contains">
        <p class="question">會否有英文版的tvb.com？</p>
        <p class="answer">
          由於TVB的節目以中文為主，所以暫時不會考慮製作英文版的網頁。<br /><br />如你想查閱更多有關無綫集團的企業資訊，請瀏覽
          <a href="https://corporate.tvb.com/" target="_blank">https://corporate.tvb.com/</a>。
        </p>
        <p class="question">可否在我的網頁上放置超連結指向tvb.com？</p>
        <p class="answer">
          我們歡迎任何網頁放置超連結至tvb.com。如有特別要求或查詢，請以電郵<a
            href="mailto:info@tvb.com"
            >聯絡我們</a
          >，並留下姓名、代表機構或其他有關資料。
        </p>
        <p class="question">可否於貴網站放置廣告？</p>
        <p class="answer">
          如閣下有意洽談有關tvb.com網站廣告問題，請<a href="mailto:info@tvb.com">聯絡我們</a
          >的營業代表，或到<a href="http://ad.tvb.com/" target="_blank">http://ad.tvb.com/</a
          >了解詳情。
        </p>
      </div>
      <div v-else class="corporation-contains">
        <p class="question">Will there be an English version of tvb.com?</p>
        <p class="answer">
          Since TVB's programmes are mainly in Chinese language, at this point of time, we do not
          have plans to include an English version for our website.<br /><br />For more corporate
          information about the TVB Limited, please visit
          <a href="https://corporate.tvb.com/" target="_blank">https://corporate.tvb.com/</a>.
        </p>
        <p class="question">Can we establish a hyperlink from my website to tvb.com's website?</p>
        <p class="answer">
          We welcome any website to establish hyperlink to tvb.com's website. If there are any
          special requests or enquiries, please <a href="mailto:info@tvb.com">email to us</a>, and
          leave us your name, organization or any other relevant information.
        </p>
        <p class="question">Can we place advertisement on your website?</p>
        <p class="answer">
          If you are interested in advertising at tvb.com, please
          <a href="mailto:info@tvb.com">contact</a> our sales representative, or visit
          <a href="http://ad.tvb.com/" target="_blank">http://ad.tvb.com/</a> for more details.
        </p>
      </div>
    </Faq>
  </section>
</template>

<script setup name="Terms_e">
import { provide, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'

import Faq from '@/components/Faq/index.vue'

const route = useRoute()
const language = ref(route?.meta?.language || 'tc')
provide('language', language)

const changeLang = (lang) => {
  language.value = lang
}

onMounted(() => {
  const superUpdatesMeta = document.createElement('meta')
  superUpdatesMeta.name = 'tvb'
  superUpdatesMeta.content = 'true'
  document.querySelector('head').appendChild(superUpdatesMeta)
})
</script>

<style lang="scss" scoped>
.tvb-terms {
  outline: none;
  display: flex;
  padding-top: 8px;
  padding-bottom: 8px;
  min-height: 360px;

  & .corporation-contains {
    color: #1e1e1e;
    font-family: 'Noto Sans CJK TC';
    font-size: 16px;
    letter-spacing: 0.1px;

    & .question {
      font-size: 21px;
      font-weight: 500;
      margin-block-end: 8px;
    }

    & .answer {
      margin-bottom: 1em;
    }

    & a {
      color: #0062a3;
    }
  }

  @media (max-width: 800px) {
    .corporation-contains {
      font-size: 14px;
      letter-spacing: 0;

      & .question {
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0;
        margin-block-end: 4px;
      }
    }
  }

  & :deep(.tvb-term-content) {
    display: flex;

    & > .term-content-detail {
      // width: calc(100% - 273px);
      width: 78%;
      max-width: 1111px;
      margin-left: 20px;
    }

    @media (max-width: 800px) {
      display: block;

      & > .term-content-detail {
        width: 100%;
        margin: 0px;
      }
    }
  }
}
</style>
